/* eslint-disable @typescript-eslint/no-explicit-any */
import { ProductStockStatus } from '@/constants'
import useCurrencyNumber from '@/hooks/useCurrencyNumber'
import type { GiftItems, OtherOffers, ProductDetail } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import { useMemo } from 'react'
import ImageOptimize from '../ImageOptimize'

interface Props {
  entrySummaryData: ProductDetail
  listGift?: GiftItems[] | undefined
  listOffer?: OtherOffers[] | undefined
  className?: string
}

const ProductGiftList = ({
  entrySummaryData,
  listGift,
  listOffer,
  className,
}: Props) => {
  const format = useCurrencyNumber()

  const stockStatus = useMemo(() => {
    if (entrySummaryData?.stockStatus && !entrySummaryData?.flashSale) {
      if (entrySummaryData.stockStatus === ProductStockStatus.ARRIVING) {
        return ProductStockStatus.IN_STOCK
      }
      return entrySummaryData?.stockStatus
    }
    return ProductStockStatus.IN_STOCK
  }, [entrySummaryData])

  const giftReduce = listGift?.map(e => ({
    ...e,
    type: 'gift',
    order: e?.optionBuy ? 1 : 2,
  })) as any

  const offerReduce = listOffer?.map((e: any) => ({
    ...e,
    type: 'offer',
    order: e?.content?.featured ? 0 : 3,
  })) as any

  const dataGift = [...giftReduce, ...offerReduce]?.sort(
    (a: any, b: any) => a?.order - b?.order
  )

  if (
    [
      ProductStockStatus.OUT_OF_STOCK,
      ProductStockStatus.OUT_OF_BUSINESS,
    ].includes(stockStatus as ProductStockStatus) ||
    !dataGift?.length
  ) {
    return null
  }

  return (
    <div
      className={`priceNotLogin overflow-hidden rounded-xl border border-[#D1D5DB] text-sm text-black-400 ${className}`}
    >
      <h2 className='bg-[#F3F4F6] px-5 py-4 font-semibold'>
        Khuyến mãi kèm theo
      </h2>
      <div className='flex flex-col gap-4 bg-white px-5 py-4'>
        {dataGift?.map((e: any) => (
          <div className='flex gap-2' key={e._id}>
            <ImageOptimize
              src='/assets/icons/giftbox.svg'
              alt='gift box'
              width={18}
              height={18}
              className='h-[18px] w-[18px]'
            />

            {e.type == 'gift' ? (
              <div className='w-full gap-x-2'>
                <span>{getTranslate(e?.name)}</span>
                {e?.optionBuy
                  ? e?.displayPrice &&
                    e?.price > 0 && (
                      <span className='italic'>
                        <span> (Không lấy quà trừ </span>
                        <span className='text-sm font-bold text-orange'>
                          {format(e?.price)})
                        </span>
                      </span>
                    )
                  : e?.displayPrice &&
                    e?.price > 0 && (
                      <span className='italic'>
                        <span> (trị giá </span>
                        <span className='text-sm font-bold text-orange'>
                          {format(e?.price)})
                        </span>
                      </span>
                    )}
                {e.viewMoreLink && (
                  <Link
                    href={e.viewMoreLink || '/'}
                    target='_blank'
                    className='ml-[5px] italic text-link'
                  >
                    (Chi tiết)
                  </Link>
                )}
              </div>
            ) : (
              <div className='text-black text-sm'>
                <span className={`${e.content.featured ? 'font-bold' : ''}`}>
                  {getTranslate(e?.content?.name)}
                </span>
                {e.content?.viewMoreLink && (
                  <Link
                    href={e.content.viewMoreLink || '/'}
                    target='_blank'
                    className='ml-[5px] italic text-link'
                  >
                    (Chi tiết)
                  </Link>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ProductGiftList
